import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const LanguageContext = createContext();
const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const response = await axios.get(`${serverBaseUrl}/api/translations`);
        setTranslations(response.data);
      } catch (error) {
        console.error('Error fetching translations:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTranslations();
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translations, loading }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);